import { map, OperatorFunction, pairwise, startWith } from 'rxjs';
import { ResponseValue } from '../../models';

export function pickAnsweredQuestions(
  initialValue: Record<string, ResponseValue>
): OperatorFunction<Record<string, ResponseValue>, string[]> {
  return (source) =>
    source.pipe(
      startWith(initialValue),
      pairwise(),
      map(([previous, current]) =>
        Object.keys(current).filter(
          (reference) => current[reference] && !previous[reference]
        )
      )
    );
}
